<template>
  <layout-home class="home-section">
    <section class="hero">
      <div class="container">
        <LoginForm/>
      </div>
    </section>
  </layout-home>
</template>

<script>
import LayoutHome from '@/layouts/LayoutHome'
import LoginForm from '@/components/LoginForm'
import {mapGetters} from 'vuex'

export default {
  name: 'Home',
  components: {
    LayoutHome,
    LoginForm
  },

  data() {
    return {
      isComponentModalActive: false,
      backendVersions: {},
      frontendVersions: {},
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({currentUser: "auth/currentUser"})
  },
}
</script>
